import ITEM_UNAVAILABLE_IMG from '@hotjar/shared-assets/images/error-404.png';
import { useTranslation } from '@hotjar/translations';
import { CentralMessage } from './CentralMessage';

export const ItemUnavailableRoute = (): JSX.Element => {
  const { t } = useTranslation('common', { keyPrefix: 'error-pages.item-unavailable' });
  return (
    <CentralMessage
      pageImg={ITEM_UNAVAILABLE_IMG}
      pageTitle={t('title')}
      pageImgAlt={t('image-alt')}
      pageDescription={t('description')}
    />
  );
};
